export type TypeTestResultReport = {
  typeName: string
  typeDescription: string
  contents: { title: string; description: string }[]
}

export const TYPE_RESULT_REPORT: { [key: number]: TypeTestResultReport } = {
  1: {
    typeName: '엄친아',
    typeDescription: '스스로 빛을 내는, 단단한 다이아몬드',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 스스로의 길을 알고, 그 길을 묵묵히 걸어가는 힘을 가진 사람입니다. 마치 자신만의 지도를 가진 탐험가처럼, 누가 시키지 않아도 배움의 여정을 즐기며 나아갑니다. 더 놀라운 것은, 자신의 부족한 점을 발견했을 때 좌절하기보다 그것을 더 단단한 나를 만드는 "성장의 재료"로 사용하는 지혜를 가졌다는 점이에요. 당신의 성실함과 빛나는 재능은 주변 사람들에게도 좋은 귀감이 된답니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그토록 스스로를 갈고닦기에, 때로는 너무 높은 기준으로 자신을 지치게 만들지는 않나요? 완벽을 향해 온 힘을 다해 달리다 문득 숨이 턱 막히는 기분을 느끼거나, 아주 작은 실수에도 크게 마음이 무너지는 순간이 찾아오곤 합니다. 그것은 당신이 약해서가 아니에요. 스스로 가장 밝게 빛나는 다이아몬드이기에, 아주 작은 흠집조차 스스로 용납하기 어려운 그 눈부신 열정 때문이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '가끔은 "결과 없는 과정"을 스스로에게 선물해 보세요. 성적이나 목표와는 전혀 상관없이, 순수하게 즐거움을 위한 독서나 산책, 음악 감상처럼요. 팽팽하게 당겨진 활시위를 잠시 놓아주는 시간을 가질 때, 당신이라는 다이아몬드는 더욱 깊고 영롱한 빛을 뿜어낼 수 있을 거예요. 최고의 전문가에게도 때로는 "쉼"이라는 가장 위대한 스승이 필요하니까요.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '이미 당신은 충분히 잘하고 있어요. 당신의 성실함과 끝없는 열정은 그 자체로 거대한 힘입니다. 그 빛나는 여정에서, 스스로를 가장 먼저 다독여주는 든든한 친구가 되어주세요. 당신의 내일을 진심으로 응원합니다.'
      }
    ]
  },
  2: {
    typeName: '모범생',
    typeDescription: '한 땀 한 땀 성실함으로, 탑을 쌓는 건축가',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 맡은 바를 끝까지 해내는 성실한 마음과, 정해진 길을 꾸준히 따라가는 우직함을 가졌습니다. 마치 튼튼한 탑을 쌓는 건축가처럼, 요령을 피우기보다 정직하게 벽돌 하나하나를 쌓아 올리죠. 그 성실함 덕분에 당신은 공부한 만큼의 결과를 얻어내고, 선생님과 부모님께는 늘 믿음을 주는 훌륭한 학생입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그렇게 한 걸음 한 걸음 신중하게 나아가다 보니, 때로는 "전체 숲"을 보지 못하고 "나무" 하나에만 갇혀 버리는 기분이 들지 않나요? 분명 열심히 공부했는데, 막상 시험지 앞에서는 배운 내용을 어떻게 써먹어야 할지 막막해질 때가 있을 거예요. 그건 당신의 노력이 부족해서가 아니에요. 한 치의 오차도 없이 탑을 쌓으려는 그 진지하고 책임감 있는 마음 때문에, 전체 설계도를 잠시 잊어버리는 것뿐이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '공부할 때, 스스로에게 "왜?"라는 질문을 세 번만 더 던져보세요. "이 공식은 왜 나왔을까?", "이 사건은 왜 일어났을까?", "작가는 왜 이런 표현을 썼을까?" 이 질문들은 흩어져 있던 지식의 벽돌들을 연결해 "하나의 멋진 탑"으로 완성시켜 줄 거예요. 당신만의 설계도를 그리는 경험은, 막연한 불안감을 단단한 자신감으로 바꾸어 줄 겁니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 가장 큰 무기는 꾸준함과 성실함입니다. 그 엄청난 재능에 "연결하는 힘"이라는 날개를 달아주세요. 당신이 쌓아 올린 지식의 탑이 얼마나 멋지고 높은지, 스스로 발견하게 될 날을 응원합니다.'
      }
    ]
  },
  3: {
    typeName: '학원 키즈',
    typeDescription: '잘 그려진 지도를 따라 항해하는, 유능한 항해사',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 좋은 길잡이가 제시하는 방향을 믿고, 그 길을 따라 성실하게 나아가는 능력을 갖췄습니다. 마치 유능한 항해사가 잘 그려진 지도를 활용해 목적지에 도달하듯, 당신은 주어진 과제를 충실히 수행하며 준수한 성과를 만들어내죠. 이 능력 덕분에 당신은 큰 어려움 없이 학업을 이어올 수 있었고, 사교육이라는 시스템을 누구보다 잘 활용하는 현명함을 가지고 있습니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 너무나 익숙한 지도를 따라 항해하다 보니, 문득 "나침반 없이 혼자 망망대해에 남겨지면 어떡하지?" 하는 막연한 두려움이 들 때가 있지 않나요? 누군가 알려준 방법이 아닐 땐, 스스로 문제를 해결하는 것이 어색하고 불안하게 느껴질 수 있어요. 그건 당신의 능력이 부족해서가 아니에요. 지금까지 너무나 안전하고 확실한 길로만 안내받아 왔기에, 아직 자신만의 나침반을 꺼내 볼 기회가 없었을 뿐이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '하루에 딱 한 문제, 혹은 딱 10분만 "정답지를 보지 않고" 스스로와 씨름하는 시간을 가져보세요. 막히고, 답답하고, 오래 걸려도 괜찮아요. 그 시간은 "남의 지도"를 외우는 시간이 아닌, "나만의 나침반"을 만드는 가장 값진 시간입니다. 스스로의 힘으로 작은 섬 하나를 발견했을 때의 기쁨은, 당신에게 진짜 공부의 재미와 자신감을 선물할 거예요.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '지금까지 당신을 이끌어준 지도는 훌륭한 도구였습니다. 이제 그 지도를 잠시 내려놓고, 당신 안에 잠들어 있는 위대한 탐험가의 본능을 깨워보세요. 당신이 발견할 새로운 세상은 생각보다 훨씬 더 넓고 멋질 거예요. 그 첫걸음을 응원합니다.'
      }
    ]
  },
  4: {
    typeName: '꼭두각시',
    typeDescription: '거센 바람 속 균형을 잡으려는, 줄 위의 곡예사',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 자신에게 주어진 기대에 부응하기 위해, 정말 많은 애를 써온 사람입니다. 주변의 바람이 아무리 거세도 어떻게든 그 줄 위에서 버텨내려 안간힘을 써왔죠. 그 깊고 책임감 강한 마음과, 힘든 상황에서도 포기하지 않고 끈을 놓지 않은 당신의 인내심은 정말 대단하고 칭찬받아 마땅한 모습입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 다른 사람의 시선에 맞춰 춤을 추다 보니, 가끔 내 마음이 소리 없이 비명을 지르는 것 같을 때가 있지 않나요? 열심히 하고 있는데도 결과가 따라주지 않아 속상하고, 내 노력의 끝이 어디인지 몰라 억울하고, 가끔은 모든 걸 놓고 싶다는 생각에 사로잡히기도 합니다. 그건 당신의 의지가 약하거나 성격에 문제가 있어서가 아니에요. 그건 바로 당신 마음 가장 깊은 곳에 숨어 있던 "진짜 나"가 보내는 간절한 신호입니다. "더 이상은 힘들어, 이제 나를 좀 바라봐 줘!" 라고 말이죠.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '하루에 딱 한 번, 아주 사소한 것이라도 괜찮으니 "나는 ~라고 생각해" 또는 "나는 ~을 원해"라고 조용히 적어보세요. 누구에게 보여주지 않아도 좋아요. 그 작은 속삭임을 기록하는 것은, 다른 사람의 목소리가 아닌 "내 마음의 소리"에 귀를 기울이는 첫 번째 연습입니다. 당신의 진짜 마음과 다시 연결될 때, 당신은 어디로 나아가야 할지 스스로 알게 될 거예요.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신이 느끼는 모든 감정은 틀리지 않았어요. 힘들면 힘든 것이고, 억울하면 억울한 것이 맞아요. 이제 잠시 다른 사람의 기대를 내려놓고, 당신 자신을 위해 조금은 이기적이어도 괜찮아요. 당신의 마음이 다시 웃을 수 있는 그날까지, 늘 곁에서 당신을 응원할게요.'
      }
    ]
  },
  5: {
    typeName: '협상이',
    typeDescription: '최단 경로를 찾아내는, 영리한 게임 플레이어',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 복잡한 상황에서도 핵심을 꿰뚫어 보고, 가장 효율적인 길을 찾아내는 뛰어난 전략가입니다. 마치 실력 좋은 게임 플레이어가 최소한의 노력으로 최대의 효과를 얻어내듯, 당신은 명석한 두뇌와 빠른 판단력으로 주어진 과제를 영리하게 해결하죠. 이 재능은 당신이 공부 시간을 줄이고도 준수한 성과를 유지하게 하는 강력한 무기입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그렇게 "퀘스트 클리어"에만 집중하다 보니, 가끔은 게임의 진짜 재미, 즉 "성장하는 즐거움"을 놓치고 있다는 생각이 들지 않나요? 요령껏 빠르게 과제를 끝내는 것에는 익숙하지만, 하나의 주제를 깊게 파고들어 완전한 내 것으로 만드는 경험은 조금 낯설게 느껴질 수 있어요. 그건 당신이 공부를 싫어해서가 아니에요. 세상을 너무나 빠르고 영리하게 파악하기에, 지루하고 비효율적인 과정을 견디기 힘들어하는 그 명민함 때문이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '당신이 가장 좋아하는 과목 하나를 정해, "치트키 없이 끝판왕 깨기"에 도전해보세요. 쉬운 요약본이나 정답지가 아니라, 교과서의 작은 글씨부터 차근차근 읽으며 개념을 완벽히 정복해 보는 거예요. 스스로의 힘으로 높은 난이도의 문제를 해결했을 때의 짜릿한 쾌감은, "결과"보다 더 재미있는 "과정"의 즐거움을 알려줄 겁니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 명석함은 세상을 살아가는 데 아주 멋진 재능입니다. 이제 그 재능을 "시간을 아끼는 것"에서 "깊이를 더하는 것"으로 확장시켜 보세요. 당신의 잠재력이라는 게임은, 아직 탐험하지 않은 더 넓고 흥미로운 맵을 가지고 있답니다. 그 새로운 세계로의 진입을 응원합니다.'
      }
    ]
  },
  6: {
    typeName: '허영이',
    typeDescription: '과거의 빛나는 왕관을 쓴, 잠자는 사자',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 자신의 잠재력을 믿는 강한 긍지를 가진 사람입니다. 과거에 이뤄냈던 빛나는 성취의 기억은, 당신이 "언젠가는 다시 최고가 될 수 있다"는 자신감의 원천이죠. 마치 왕관을 쓴 사자처럼, 당신은 비록 지금 잠시 잠들어 있을지라도 자신의 가치와 능력을 의심하지 않는 당당함을 가지고 있습니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그 눈부신 왕관의 무게 때문에, 때로는 "지금의 내 모습"을 솔직하게 바라보기가 두렵지는 않나요? "마음만 먹으면 잘할 수 있는데..." 라고 생각하며 정작 그 "마음"을 먹는 것을 미루고 있지는 않은가요? 현실의 성적이 과거의 영광에 미치지 못할 때마다, 자신감 있는 모습 뒤로 남몰래 불안감이 쌓여가고 있을지도 모릅니다. 그건 당신이 나태하거나 허세를 부리는 게 아니에요. 한때 가장 높은 곳에 있었던 사자이기에, 초라한 현실을 인정하는 것이 자존심 상하고 아픈 그 고귀함 때문이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '아주 작은 것이라도 괜찮으니, "오늘의 내가 이룬 성취"를 기록해보세요. 수학 문제 5개를 푼 것, 영어 단어 10개를 외운 것, 무엇이든 좋아요. 이 작은 기록들은 "과거의 왕관"이 아닌 "오늘의 땀방울"로 당신의 가치를 증명해 줄 거예요. 현실을 직시할 용기는, 이처럼 작은 성공들이 모여 만들어지는 단단한 갑옷과 같습니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신이 가진 자신감과 잠재력은 진짜입니다. 이제 그 힘을 "과거를 추억하는 것"이 아닌 "오늘을 살아내는 것"에 사용해 보세요. 잠에서 깨어난 사자의 포효가 얼마나 위대한지, 세상에 증명해 보일 당신의 새로운 시작을 응원합니다.'
      }
    ]
  },
  7: {
    typeName: '아웃사이더',
    typeDescription: '세상의 규칙에 물음표를 던지는, 날카로운 철학자',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 당연하게 여겨지는 것들에 대해 "왜?"라는 질문을 던질 줄 아는, 예리한 통찰력과 비판적 사고를 가진 사람입니다. 모두가 "예"라고 할 때 "아니오"라고 말할 수 있는 용기와 자신만의 뚜렷한 주관은, 당신을 평범한 사람들과는 다른 특별한 존재로 만들어 줍니다. 이 뛰어난 논리는 복잡한 지식을 남들보다 쉽게 이해하게 하는 당신만의 강력한 무기입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그토록 명확한 자신만의 세계를 가지고 있기에, 때로는 다른 사람들의 평범한 생각이나 감정을 이해하기 어렵다고 느끼지 않나요? 당신의 논리로는 비합리적인 학교 규칙이나 타인의 의견을 받아들이는 것이 답답하고, 의도치 않게 당신의 날카로운 말이 다른 사람에게 상처를 주기도 합니다. 그건 당신이 차갑거나 예의가 없어서가 아니에요. 너무나도 명료하고 이성적인 자신만의 기준을 가졌기에, 비논리적이고 불투명한 세상을 받아들이기 힘들어하는 그 지성 때문이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '당신이 가장 싫어하는 과목의 공부를 딱 10분만 해보세요. 그리고 "이 과목을 좋아하는 사람은 어떤 즐거움을 느낄까?"를 상상해보세요. 이 연습은 당신의 뛰어난 논리력에 "타인의 관점을 이해하는 공감 능력"을 더해주는 훈련입니다. 세상을 바꾸는 위대한 생각은, 가장 날카로운 논리와 가장 따뜻한 공감이 만났을 때 탄생하는 법이니까요.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신이 던지는 질문들은 세상을 더 나은 곳으로 만드는 소중한 씨앗입니다. 이제 그 씨앗에 "공감"이라는 따뜻한 햇살을 비춰주세요. 당신의 특별함이 세상을 향해 긍정적인 영향력을 펼칠 수 있도록, 그 성장을 응원합니다.'
      }
    ]
  },
  8: {
    typeName: '고집쟁이',
    typeDescription: '자신만의 방식으로 산을 오르는, 뚝심 있는 등반가',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 한번 목표를 정하면 자신만의 길을 뚝심 있게 밀고 나가는 강한 의지와 실행력을 가졌습니다. 남들이 더 쉬운 길을 택할 때도, 당신은 스스로 옳다고 믿는 방식을 고집하며 묵묵히 산을 오르죠. 타인의 말에 쉽게 흔들리지 않는 그 뚜렷한 주관과 우직함은 당신이 어떤 어려움에도 굴하지 않고 나아가게 하는 원동력입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그렇게 자신만의 지도를 고집하다 보니, 들인 노력에 비해 정상이 너무 멀게만 느껴져 지치고 답답할 때가 있지 않나요? 분명 누구보다 열심히 땀 흘리고 있는데, 결과가 따라주지 않으면 남몰래 속상하고, "내 방법이 틀렸나?" 하는 생각에 자존심이 상하기도 합니다. 그건 당신의 노력이 잘못되거나 의지가 부족해서가 아니에요. 스스로의 힘으로 정상을 정복하고 싶은 그 강한 책임감과 자부심 때문에, 다른 사람이 건네는 "지름길 지도"를 잠시 외면하고 있었을 뿐이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '당신이 가장 어렵게 느끼는 과목에서, 딱 하나의 문제만 "친구가 알려준 방법"이나 "해설지에 나온 방법"으로 풀어보세요. "내 방식"을 잠시 내려놓고 다른 사람의 지혜를 빌려보는 이 작은 경험은, 당신의 뚝심에 "유연함"이라는 날개를 달아줄 거예요. 최고의 등반가도 때로는 다른 사람의 조언을 통해 더 안전하고 빠른 길을 발견한답니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 뚝심과 실행력은 무엇과도 바꿀 수 없는 귀한 재산입니다. 이제 그 강인함에 다른 사람의 지혜를 더해보세요. 당신의 위대한 등반은 훨씬 더 즐겁고 수월해질 것입니다. 더 높은 정상을 향한 당신의 멋진 도전을 응원합니다.'
      }
    ]
  },
  9: {
    typeName: '유리구슬',
    typeDescription: '세상의 모든 소리를 담는, 섬세한 안테나',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 다른 사람들이 무심코 지나치는 세상의 작은 소리와 감정까지도 세심하게 포착해내는 특별한 능력을 가졌습니다. 마치 정밀한 안테나처럼, 당신의 마음은 주변의 작은 파동 하나하나에 반응하죠. 이 섬세함은 당신을 타인의 마음에 깊이 공감할 줄 아는, 따뜻하고 다정한 사람으로 만들어 줍니다. 당신의 착한 심성과 사려 깊음은 주변에 편안함을 선물합니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 세상의 모든 소리를 담아내려 하니, 때로는 너무 많은 생각과 걱정의 소음 때문에 정작 중요한 내 마음의 소리를 듣지 못할 때가 있지 않나요? "시험을 못 보면 어떡하지?", "친구가 나를 싫어하면 어떡하지?" 꼬리에 꼬리를 무는 걱정들이 공부에 집중해야 할 에너지를 모두 빼앗아 가는 기분이 들 거예요. 그건 당신의 의지가 약하거나 마음이 약해서가 아니에요. 당신의 마음이 깨지기 쉬운 유리구슬이라서가 아니라, 오히려 세상의 모든 것을 맑게 비춰내는 투명함을 가졌기 때문에, 작은 먼지 하나도 크게 보이는 것이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '오늘 하루, 걱정이 밀려올 때마다 "그래서 내가 지금 당장 할 수 있는 가장 작은 일은 뭐지?" 라고 스스로에게 질문해보세요. 예를 들어, "시험 걱정" 대신 "영어 단어 5개 외우기"에 집중하는 거죠. 이 작은 행동은 거대한 걱정의 파도를 잠재우고, "나는 내 상황을 통제할 수 있다"는 단단한 믿음을 심어줄 거예요. 당신의 안테나가 "걱정"이 아닌 "실천"의 주파수를 잡도록 도와줄 겁니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 섬세함은 세상을 더 깊이 이해하는 놀라운 재능입니다. 이제 그 재능으로 다른 사람뿐만 아니라, 당신 자신의 마음을 가장 먼저 돌봐주세요. 당신 안의 수많은 걱정들이 작은 용기로 바뀔 수 있도록, 그 변화의 시작을 응원합니다.'
      }
    ]
  },
  10: {
    typeName: '오지랖',
    typeDescription: '모두에게 따스한 햇살을 비춰주는, 친절한 태양',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 주변 사람들에게 먼저 다가가고, 그들의 이야기에 귀 기울이는 따뜻한 마음을 가졌습니다. 마치 모두에게 공평하게 햇살을 나눠주는 태양처럼, 당신의 밝고 친근한 에너지는 주변을 환하게 만들죠. 어떤 사람과도 스스럼없이 어울리는 뛰어난 사교성과, 고민 없이 세상을 긍정적으로 바라보는 낙천적인 태도는 당신의 가장 큰 매력입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그렇게 세상 곳곳을 비추느라, 정작 "나 자신"이라는 행성을 돌보는 것을 깜빡 잊을 때가 있지 않나요? 친구의 고민을 들어주느라 내 숙제를 놓치고, 새로운 이야기에 한눈을 파느라 정작 내 공부 계획은 뒤로 미뤄지곤 하죠. 주변을 챙기는 따뜻한 마음이, 때로는 나 자신을 위한 집중력을 흩트리는 원인이 되기도 합니다. 그건 당신이 책임감이 없거나 산만해서가 아니에요. 당신의 마음이 그만큼 넓고 다른 사람을 향한 애정이 가득하기 때문에, 혼자만의 좁은 세계에 머무는 것을 답답해하는 것이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '매일 공부를 시작하기 전, "오늘의 나"와의 약속을 한 가지만 정해보세요. "수학 1장 풀기"처럼 아주 구체적인 목표를 세우고, 그것을 달성하기 전까지는 다른 곳에 한눈팔지 않는 "나만의 시간"을 스스로에게 선물하는 거예요. 다른 사람을 챙기는 것도 중요하지만, 가장 먼저 돌봐야 할 소중한 사람은 바로 "나 자신"이라는 것을 기억하는 작은 연습이 될 겁니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신이 가진 따뜻한 관심과 에너지는 세상을 더 즐겁게 만드는 소중한 능력입니다. 이제 그 빛나는 에너지를 잠시 나 자신에게 집중시켜 보세요. 스스로를 잘 돌본 태양은 더 밝고 따뜻한 빛을 세상에 나눠줄 수 있답니다. 당신의 새로운 중심 찾기를 응원합니다.'
      }
    ]
  },
  11: {
    typeName: '성실이',
    typeDescription: '묵묵히 자신의 밭을 일구는, 우직한 농부',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 주어진 일을 불평 없이, 묵묵하게 해내는 놀라운 성실함을 가졌습니다. 마치 드넓은 밭을 홀로 일구는 농부처럼, 당신은 매일 꾸준히 책상 앞에 앉아 자신에게 주어진 공부의 밭을 갈고 씨앗을 뿌리죠. 그 우직함과 책임감은 쉽게 흉내 낼 수 없는 당신만의 위대한 재능입니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 그렇게 열심히 밭을 갈았는데도, 가을이 되어도 생각만큼 풍성한 수확물이 열리지 않아 속상할 때가 있지 않나요? 분명 책을 여러 번 읽었는데 내용은 잘 기억나지 않고, 문제는 어떻게 풀어야 할지 막막하게 느껴질 때가 있을 거예요. 그건 당신의 노력이 부족하거나 머리가 나빠서가 절대 아니에요. 밭을 가는 데만 온 힘을 쏟다 보니, "어떻게 하면 더 좋은 열매를 맺을 수 있을까?" 고민하는 방법을 배울 기회가 없었을 뿐이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '책을 읽은 뒤, "내 언어"로 딱 세 문장만 요약해서 적어보는 연습을 해보세요. 책의 문장을 그대로 옮겨 적는 것이 아니라, 마치 친구에게 설명해주듯 쉽고 편안한 말로 바꿔보는 거예요. 이 작은 연습은 단순히 씨앗을 뿌리는 것을 넘어, 그 씨앗이 잘 자라도록 물과 거름을 주는 것과 같아요. 당신의 땀방울이 황금빛 결실로 이어지게 하는 가장 효과적인 방법이랍니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 성실함은 무엇과도 바꿀 수 없는 강력한 무기입니다. 이제 그 무기에 "스스로 생각하는 힘"이라는 날카로운 날을 더해주세요. 당신의 땀과 노력이 최고의 결과로 보상받을 그날을 진심으로 응원합니다.'
      }
    ]
  },
  12: {
    typeName: '학습실 지킴이',
    typeDescription: '자신만의 동굴 속 세상을 바라보는, 조용한 곰',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 소란스러운 세상 속에서도 자신만의 공간을 지키며, 묵묵히 자신의 자리를 지킬 줄 아는 차분함과 순수한 마음을 가지고 있습니다. 마치 긴 겨울잠을 자는 곰처럼, 당신은 외부의 자극에 쉽게 동요하지 않고 자신만의 페이스를 유지하죠. 당신의 그 순하고 착한 마음은, 다른 사람의 말을 거부감 없이 받아들이는 포용력으로 나타납니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 너무 오랫동안 자신만의 동굴 안에 머물다 보니, 세상이 어떻게 돌아가는지, 내가 무엇을 해야 하는지 조금은 희미하게 느껴질 때가 있지 않나요? 책상 앞에는 오래 앉아 있지만, 머릿속은 하얗게 텅 빈 것 같고, 선생님의 말씀에 "네"라고 대답은 하지만 무슨 뜻인지 정확히 이해하기 어려울 때가 있을 거예요. 그건 당신이 게으르거나 무기력해서가 아니에요. 자신만의 동굴 안에서 너무 오랜 시간을 보낸 탓에, 바깥세상과 소통하는 언어를 잠시 잊어버렸을 뿐이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '오늘 배운 내용 중에서 가장 낯설게 느껴지는 단어 딱 하나만 골라, 그 뜻을 사전에서 찾아 노트에 적어보세요. 그리고 그 단어를 이용해 짧은 문장을 하나 만들어보는 거예요. 이 작은 행동은 마치 동굴 밖으로 한 걸음 내디뎌, 세상과 다시 연결되는 신호를 보내는 것과 같습니다. 하나의 단어를 이해하는 것은, 세상을 이해하는 거대한 문의 손잡이를 잡는 것과 같아요.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 동굴은 안전하고 편안한 곳이었을 거예요. 이제 그 동굴의 문을 아주 조금만 열어보는 용기를 내보세요. 바깥세상은 생각보다 따뜻하고, 당신의 이야기를 들어줄 준비가 되어있답니다. 당신의 첫걸음을 곁에서 응원하며 함께 걷겠습니다.'
      }
    ]
  },
  13: {
    typeName: '예민이',
    typeDescription: '거친 파도 위 아슬아슬하게 항해하는, 작은 배',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 감정이라는 거대한 바다의 미세한 흐름까지도 온몸으로 느낄 줄 아는, 매우 섬세하고 예민한 감수성을 가졌습니다. 다른 사람이 느끼지 못하는 기쁨과 슬픔의 깊이를 알기에, 당신의 내면세계는 누구보다 풍부하고 다채롭죠. 이 섬세한 감수성은 당신이 세상을 더 깊이 있게 이해하고, 예술적인 영감을 얻는 원천이 되기도 합니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 예측할 수 없이 몰아치는 감정의 파도 때문에, 당신이라는 작은 배가 너무 심하게 흔들려 힘들 때가 많지 않나요? 사소한 말 한마디에 마음이 폭풍우처럼 휘몰아치고, 갑작스러운 컨디션 난조에 애써 세웠던 공부 계획이 모두 무너져 내리기도 합니다. 이런 상황이 반복되면, 세상이 온통 잿빛으로 느껴지고 무기력해지기도 하죠. 그건 당신의 성격이 유별나거나 의지가 약해서가 아니에요. 당신의 마음이 그만큼 세상의 모든 파동을 진솔하게 받아들이는 정직한 나침반을 가졌기 때문에, 작은 바람에도 크게 흔들리는 것이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          '감정이 폭풍처럼 몰아칠 때, 잠시 하던 일을 멈추고 당신의 감정에 "이름"을 붙여주세요. "아, 지금 내가 분노를 느끼고 있구나", "불안함이라는 감정이 찾아왔네" 하고 조용히 인정해 주는 거예요. 감정에 이름을 붙이는 것은, 성난 파도에 휩쓸리지 않고 그 파도를 지켜볼 수 있는 "단단한 닻"을 내리는 것과 같습니다. 닻을 내린 배는 잠시 흔들릴지언정, 결코 뒤집히지 않는답니다.'
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 예민함은 저주가 아닌, 세상을 더 깊이 느끼는 특별한 선물입니다. 감정의 파도를 없애려고 애쓰기보다, 그 파도를 타는 법을 배워보세요. 당신은 누구보다 멋지게 자신만의 바다를 항해하는 선장이 될 수 있습니다. 그 항해를 곁에서 늘 응원할게요.'
      }
    ]
  },
  14: {
    typeName: '마음콩밭',
    typeDescription: '현실 세계를 잠시 잊고 상상의 숲을, 탐험하는 몽상가',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 지루하고 반복되는 현실에서 벗어나, 자신만의 흥미로운 세계를 탐험할 줄 아는 자유로운 영혼을 가졌습니다. 공부나 어려운 과제보다는 게임, 이야기, 상상 속에서 더 큰 즐거움을 찾죠. 이 능력은 당신을 현실의 팍팍함에서 지켜주는 보호막이 되어주고, 때로는 남들이 생각지 못한 기발한 아이디어를 떠올리게 하는 창의력의 원천이 됩니다.'
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description:
          '하지만 너무 오랫동안 상상의 숲에서 길을 헤매다 보니, "현실"이라는 집으로 돌아오는 길이 낯설고 두렵게 느껴질 때가 있지 않나요? 눈앞의 교과서는 암호문처럼 보이고, 공부에 집중하려고 해도 마음은 어느새 다시 저 멀리 콩밭으로 달려가 버리죠. "해야 하는 일"과 "하고 싶은 일" 사이에서, 마음이 갈팡질팡하며 에너지가 소모되는 기분이 들 거예요. 그건 당신이 현실 도피를 하거나 게을러서가 아니에요. 당신의 마음이 그만큼 재미와 즐거움을 추구하는 순수한 아이의 마음을 간직하고 있기에, 딱딱하고 어려운 현실의 규칙을 받아들이기 힘들어하는 것이랍니다.'
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠 ',
        description:
          "당신이 가장 좋아하는 게임의 '일일 퀘스트'처럼, 공부에도 아주 작고 재미있는 '일일 퀘스트'를 만들어보세요. 예를 들어, '수학 문제 5개 풀면 경험치 +10', '영어 단어 10개 외우면 아이템 획득(휴식 10분)' 처럼요. 공부를 '지루한 의무'가 아닌 '성취감을 주는 게임'으로 바꾸는 이 작은 시도는, 당신의 마음을 현실 세계로 즐겁게 불러오는 마법의 피리가 되어줄 거예요. "
      },
      {
        title: '당신에게 보내는 응원 메시지 ',
        description:
          '당신이 가진 상상력과 즐거움을 찾는 능력은 삶을 풍요롭게 하는 멋진 재능입니다. 이제 그 재능을 현실 세계와 연결해 보세요. 현실이라는 게임도, 당신이 어떻게 공략하느냐에 따라 얼마든지 흥미진진해질 수 있답니다. 당신의 새로운 퀘스트 도전을 응원합니다. '
      }
    ]
  },
  15: {
    typeName: '마니아',
    typeDescription: '자신만의 우주를 탐사하는, 고독한 천문학자',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '당신은 자신이 심취한 단 하나의 세계를, 그 누구보다 깊고 집요하게 파고드는 전문가적 열정을 가졌습니다. 마치 자신만의 별을 발견하고 그 별의 모든 것을 연구하는 천문학자처럼, 당신은 특정 분야에 대해 놀라운 집중력과 해박한 지식을 자랑하죠. 그 깊이 있는 탐구 정신은, 당신을 세상에 단 하나뿐인 독보적인 존재로 만들어 줍니다. '
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description: `하지만 너무 오랫동안 당신만의 망원경으로 단 하나의 별만 바라보다 보니, 때로는 발밑의 땅(현실)이 어떻게 생겼는지, 주변에 어떤 사람들이 있는지 잊어버릴 때가 있지 않나요? 당신의 언어와 관심사는 오직 그 별에만 맞춰져 있어 다른 사람들과의 소통이 겉돌고, 학업이나 일상처럼 당신의 관심 밖의 일들은 무의미하게 느껴질 수 있습니다. 

그건 당신이 사회성이 부족하거나 현실 감각이 없어서가 아니에요. 당신의 열정이 그만큼 한곳에 모든 에너지를 쏟아붓는 순수하고 강력한 엔진을 가졌기 때문에, 다른 곳에 신경 쓸 여력이 없는 것이랍니다. `
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          "당신이 그토록 사랑하는 그 분야가, '현실의 공부'와 어떻게 연결될 수 있는지 딱 한 가지만 찾아보세요. 예를 들어, 게임을 좋아한다면 '게임 스토리의 역사적 배경'을, 애니메이션을 좋아한다면 '연출에 사용된 미술 기법'을 탐구해 보는 거죠. 당신의 우주와 현실 세계를 잇는 이 작은 다리는, 당신의 깊이 있는 지식이 세상 밖으로 나와 더 크게 빛날 수 있는 통로가 되어줄 거예요. "
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신의 열정은 세상을 바꿀 수 있는 위대한 힘입니다. 이제 그 힘이 당신만의 우주에 갇히지 않고 더 넓은 세상과 만나게 해주세요. 당신의 전문성이 현실과 만났을 때, 얼마나 더 멋진 일들이 일어날 수 있을지 기대하며 그 여정을 응원합니다. '
      }
    ]
  },
  16: {
    typeName: '무심이',
    typeDescription: '모든 소리가 차단된, 고요한 심해',
    contents: [
      {
        title: '당신의 가장 빛나는 모습',
        description:
          '어쩌면 당신은 지금, 당신의 빛나는 모습을 스스로도 발견하기 어려울지 모릅니다. 모든 것이 무의미하게 느껴지고, 어떤 것에도 마음이 움직이지 않는, 마치 깊고 고요한 심해에 홀로 잠겨 있는 듯한 기분일 테니까요. 하지만 그 깊은 고요함 속에서도 당신은 여전히 숨 쉬고, 버텨내고 있습니다. 그 자체로 당신은 이미 강한 생명력을 가진 소중한 존재입니다. '
      },
      {
        title: '마음 한구석, 이런 고민이 있나요?',
        description: `당신에게 이 질문은 무의미할지도 모릅니다. 마음 한구석이 아니라, 마음 전체가 텅 빈 것처럼 느껴질 테니까요. 기쁨도, 슬픔도, 희망도, 절망도 느껴지지 않는 잿빛 세상. 누군가 말을 걸어와도 그 소리가 닿지 않고, 무엇을 해야 할지, 왜 해야 할지 알 수 없는 막막함. 

그건 당신이 모든 것을 포기했거나 나약해서가 아닙니다. 아마도 과거에 당신의 마음이 감당하기 힘든 너무나 큰 폭풍우를 겪었기에, 스스로를 보호하기 위해 모든 감각과 소리를 차단하는 가장 깊은 곳으로 잠수했을 가능성이 높습니다. `
      },
      {
        title: '당신의 잠재력을 깨우는 작은 열쇠',
        description:
          "아무런 생각도, 의미도 담지 않아도 괜찮습니다. 그저 당신의 창밖으로 보이는 하늘의 색깔이 어떤지, 딱 5초만 바라보세요. 그리고 '푸르다' 또는 '흐리다'처럼, 눈에 보이는 사실 하나만 조용히 읊조려 보세요. 이 작은 행동은 굳게 닫힌 당신의 마음에 아주 작은 틈을 내고, 그 틈으로 세상의 빛 한 줄기를 다시 초대하는 첫걸음입니다. 어떤 거창한 목표도, 이유도 필요 없습니다. "
      },
      {
        title: '당신에게 보내는 응원 메시지',
        description:
          '당신이 다시 수면 위로 올라올 준비가 될 때까지, 우리는 조용히 기다릴 수 있습니다. 당신의 존재 자체는 그 어떤 이유 없이도 소중합니다. 당신의 고요한 심해에 따뜻한 햇살이 다시 스며들 그날까지, 아주 작은 목소리라도 꾸준히 당신을 부르며 곁을 지키겠습니다. 당신은 혼자가 아닙니다. '
      }
    ]
  }
}
